/**
 * Public social profiles for Sweet Listeners.
 * Same icon row on the waitlist footer and the TEST marketplace footer.
 * Brand fills — not charcoal currentColor.
 */

const SITE_SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/sweetlisteners/',
    variant: 'instagram',
    fill: '#E4405F',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/sweetlisteners',
    variant: 'path',
    fill: '#1877F2',
    path:
      'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  },
  {
    label: 'X',
    href: 'https://x.com/sweetlisteners',
    variant: 'path',
    fill: '#0B2B5B',
    path:
      'M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z',
  },
  {
    label: 'Reddit',
    href: 'https://www.reddit.com/r/sweetlisteners',
    variant: 'path',
    fill: '#FF4500',
    path:
      'M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z',
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@sweetlisteners',
    variant: 'tiktok',
    fill: '#000000',
    path:
      'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.69 2.58-4.82 1.66-1.28 3.82-1.77 5.8-1.32.47.1.94.26 1.38.46v5.12c-.48-.16-.99-.24-1.5-.22-1.42.04-2.72.96-3.23 2.26-.32.82-.23 1.74.18 2.49.55 1.07 1.73 1.75 2.95 1.71 1.2-.03 2.29-.69 2.93-1.69.13-.21.23-.44.3-.67.04-2.89.03-5.78.04-8.67z',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@sweetlisteners-g2d',
    variant: 'path',
    fill: '#FF0000',
    path:
      'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
];

const SITE_FOOTER_COPYRIGHT = '© 2026 Sweet Listeners LLC';

const SITE_FOOTER_LEGAL_LINKS = [
  { label: 'About', href: '/about', name: 'AboutPage' },
  { label: 'How it works', href: '/how-it-works', name: 'HowItWorksPage' },
  { label: 'FAQ', href: '/faq', name: 'FAQPage' },
  { label: 'Safety', href: '/safety', name: 'SafetyPage' },
  {
    label: 'Community Guidelines',
    href: '/safety#community-guidelines',
    name: 'SafetyPage',
    to: { hash: 'community-guidelines' },
  },
  { label: 'Terms', href: '/terms-of-service', name: 'TermsOfServicePage' },
  { label: 'Privacy', href: '/privacy-policy', name: 'PrivacyPolicyPage' },
  { label: 'SMS Terms', href: '/sms-terms', name: 'SmsTermsPage' },
  { label: 'Contact', href: '/contact', name: 'ContactPage' },
  { label: 'Tech Support', href: '/help', name: 'HelpPage' },
];

const SITE_FOOTER_LEGAL_ALIASES = ['/terms', '/privacy'];
const SOCIAL_ICON_SIZE = 26;

const instagramSvgMarkup = () =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${SOCIAL_ICON_SIZE}" height="${SOCIAL_ICON_SIZE}" aria-hidden="true" focusable="false">` +
  `<defs><linearGradient id="sl-ig" x1="0" y1="1" x2="1" y2="0">` +
  `<stop offset="0" stop-color="#F9CE34"/><stop offset="0.45" stop-color="#EE2A7B"/><stop offset="1" stop-color="#6228D7"/>` +
  `</linearGradient></defs>` +
  `<rect x="2" y="2" width="20" height="20" rx="5.5" fill="url(#sl-ig)"/>` +
  `<circle cx="12" cy="12.15" r="4.55" fill="none" stroke="#fff" stroke-width="1.85"/>` +
  `<circle cx="17.15" cy="6.85" r="1.2" fill="#fff"/>` +
  `</svg>`;

const tiktokSvgMarkup = path =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${SOCIAL_ICON_SIZE}" height="${SOCIAL_ICON_SIZE}" aria-hidden="true" focusable="false">` +
  `<path fill="#69C9D0" d="${path}" transform="translate(1.15 .7)"/>` +
  `<path fill="#EE1D52" d="${path}" transform="translate(-.85 -.45)"/>` +
  `<path fill="#000000" d="${path}"/>` +
  `</svg>`;

const pathSvgMarkup = ({ path, fill }) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${SOCIAL_ICON_SIZE}" height="${SOCIAL_ICON_SIZE}" aria-hidden="true" focusable="false">` +
  `<path fill="${fill}" d="${path}"/>` +
  `</svg>`;

const socialIconSvg = link => {
  if (link.variant === 'instagram') {
    return instagramSvgMarkup();
  }
  if (link.variant === 'tiktok') {
    return tiktokSvgMarkup(link.path);
  }
  return pathSvgMarkup(link);
};

module.exports = {
  SITE_SOCIAL_LINKS,
  SITE_FOOTER_COPYRIGHT,
  SITE_FOOTER_LEGAL_LINKS,
  SITE_FOOTER_LEGAL_ALIASES,
  SOCIAL_ICON_SIZE,
  socialIconSvg,
};
